// extracted by mini-css-extract-plugin
module.exports = {"AuthorImage":"Author_AuthorImage__33z7_"};